<template>
  <div class="imgsort-list">
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">数据类型</span>
        <el-select v-model="dataType" @change="shopId = ''">
          <div v-for="item in dataTypeList" :key="item.value">
            <el-option :label="item.name" :value="item.value"></el-option>
          </div>
        </el-select>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">店铺ID</span>
        <el-input class="w200" style="width: 200px" :disabled="dataType == 1" v-model="shopId" placeholder="请输入店铺ID"></el-input>
      </div>
      <div class="condition-wrap">
        <el-button @click="getImgList" type="primary">筛选</el-button>
      </div>
      <div class="condition-wrap">
        <el-button @click="addBtn" type="success">新增分类</el-button>
      </div>
    </div>
    <el-table :data="tableData" row-key="categoryId" style="width: 100%" size="middle" border stripe>
      <el-table-column prop="categoryId" label="分类ID" width="80" align="center"></el-table-column>
      <el-table-column prop="categoryName" label="分类名称"></el-table-column>
      <el-table-column label="分类图片" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.categoryImageUrl + '?x-oss-process=image/resize,w_200'" width="120" alt />
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="120" align="center"></el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status">启用</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="140" align="center">
        <template slot-scope="scope">
          <el-button size="small" type="primary" plain @click="btnEdit(scope.row.categoryId)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="新增分类" @close="clearData" :visible.sync="showPop" width="600px">
      <el-form :model="form" size="small" label-width="100px">
        <el-form-item label="数据类型">
          <el-select  v-model="form.dataType" @change="form.shopId = ''">
            <div v-for="item in dataTypeList" :key="item.value">
              <el-option :label="item.name" :value="item.value"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺ID">
          <el-input class="w200" v-model="form.shopId"  :disabled="form.dataType == 1" controls-position="right" placeholder="请输入店铺ID"></el-input>
        </el-form-item>
        <el-form-item label="分类名称">
          <el-input v-model="form.categoryName" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="分类排序">
          <el-input-number v-model="form.sort" controls-position="right" :min="1"></el-input-number>
        </el-form-item>

        <el-form-item label="分类图片">
          <el-upload class="upload-demo" :file-list="form.fileList" :action="ossUrl" :data="ossData" :limit="1" :on-success="uploaded" :on-change="uploadCg" list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">图片大小不能超过20MB</div>
          </el-upload>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option :value="1" label="启用"></el-option>
            <el-option :value="0" label="禁用"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="showPop = false">取 消</el-button>
        <el-button type="primary" @click="addImgSort">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改图案分类" :visible.sync="showPop3" width="600px">
      <el-form :model="editForm" size="small" label-width="100px">
        <el-form-item label="分类名称">
          <el-input v-model="editForm.categoryName" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="分类排序">
          <el-input-number v-model="editForm.sort" controls-position="right" :min="1"></el-input-number>
        </el-form-item>

        <el-form-item label="分类图片">
          <div v-if="!editimgup">
            <img :src="editForm.categoryImageUrl + '?x-oss-process=image/resize,w_200'" width="100" style="vertical-align: middle" />
            <el-button size="small" type="text" @click="editimgup = true">修改图片</el-button>
          </div>
          <el-upload v-else class="upload-demo" :action="ossUrl" :data="ossData" :limit="1" :on-success="uploaded('edit')" :on-change="uploadCg" list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">图片大小不能超过20MB</div>
          </el-upload>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="editForm.status" placeholder="请选择">
            <el-option :value="1" label="启用"></el-option>
            <el-option :value="0" label="禁用"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间">{{ editForm.createTime }}</el-form-item>
        <el-form-item label="更新时间">{{ editForm.updateTime }}</el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="showPop3 = false">取 消</el-button>
        <el-button type="primary" @click="editImgSort">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '../lib/API'
import dataTypeList from '../lib/dataTypeList'
export default {
  name: 'OrderList',
  data() {
    return {
      editimgup: false,
      tableData: [],
      showPop: false,
      showPop3: false,
      form: {
        categoryName: '',
        categoryImageKey: '',
        sort: '',
        status: 1,
        dataType: '1',
        shopId: '',
        fileList: []
      },
      ossUrl: '',
      ossData: {},
      editForm: {},
      editName: '',
      editUpload: false,
      // 数据类型列表
      dataTypeList,
      // 数据类型
      dataType: '1',
      shopId: ''
    }
  },
  methods: {
    clearData () {
      console.log('clearData')
      this.form =  {
        categoryName: '',
        categoryImageKey: '',
        sort: '',
        status: 1,
        dataType: '1',
        shopId: '',
        fileList: []
      }
    },
    addImgSort() {
      new API(this).POST({
        url: '/designCategory/addDesignCategory',
        params: this.form,
        cb: res => {
          if (res === null) {
            this.showPop = false
            this.clearData()
            this.getImgList()
          }
        }
      })
    },
    addBtn() {
      this.showPop = true
      this.ossUrl = ''
      this.ossData = {}
      this.getOsspop()
    },
    getOsspop() {
      new API(this).POST({
        url: '/oss/getSignature',
        params: {
          count: 1,
          type: 4
        },
        cb: res => {
          this.ossUrl = res.url
          this.ossData = res.signatures[0]
        }
      })
    },
    uploaded(type) {
      if (type === 'edit' && this.editUpload) {
        this.editForm.categoryImageKey = this.ossData.key
      } else {
        this.form.categoryImageKey = this.ossData.key
      }
    },
    uploadCg(file) {
      let ext = file.raw.type
      ext = ext ? '.' + ext.split('/')[1] : ''
      let hasExt = this.ossData.key.indexOf('.')
      if (hasExt === -1) {
        this.ossData.key += ext
      } else {
        this.ossData.key = this.ossData.key.slice(0, hasExt)
        this.ossData.key += ext
      }

      this.editUpload = true
    },
    btnEdit(id) {
      this.getOsspop()
      this.editUpload = false
      this.editimgup = false
      new API(this).POST({
        url: `/designCategory/getDesignCategoryDetail?categoryId=${id}`,
        cb: res => {
          this.editForm = res
          this.showPop3 = true
          this.editName = res.categoryName
        }
      })
    },
    editImgSort() {
      let { categoryId, categoryImageKey, categoryName, sort, status } = this.editForm

      if (!categoryName) {
        this.$message.error('请填写分类名~')
        return
      }

      let formData = {
        categoryId,
        categoryImageKey,
        sort,
        status
      }

      if (categoryName !== this.editName) {
        formData.categoryName = categoryName
      }

      new API(this).POST({
        url: '/designCategory/updateDesignCategory',
        params: formData,
        cb: res => {
          if (res === null) {
            this.showPop3 = false
            this.getImgList()
          }
        }
      })
    },
    getImgList() {
      new API(this).POST({
        url: '/designCategory/findAllDesignCategoryList',
        params: {
          dataType: this.dataType,
          shopId: this.shopId
        },
        cb: res => {
          this.tableData = res
        }
      })
    }
  },
  created() {
    this.getImgList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ImgSort.vue